import React, { useState } from "react";
import RoutePanel from "@/components/RoutePanel";
import RouteCompare from "@/components/RouteCompare";
import PortfolioPanel from "@/components/PortfolioPanel";
import HistoryPanel from "@/components/HistoryPanel";

export default function SidePanel({ quoteCtx, routes = [], historyVersion, selectedRouteIndex, onSelectRoute }) {
  const [tab, setTab] = useState("route");
  return (
    <div className="panel overflow-hidden">
      <div className="flex items-center justify-between px-3 sm:px-4 h-12 border-b border-[var(--border)] gap-2">
        <div className="tabs overflow-x-auto no-scrollbar">
          {[
            { k: "route", label: "Route" },
            { k: "compare", label: "Compare" },
            { k: "portfolio", label: "Portfolio" },
            { k: "history", label: "History" },
          ].map((t) => (
            <div
              key={t.k}
              className="tab-item flex-shrink-0"
              data-active={tab === t.k}
              onClick={() => setTab(t.k)}
              data-testid={`side-tab-${t.k}`}
            >
              {t.label}
            </div>
          ))}
        </div>
        <span className="text-[10.5px] text-[var(--text-subtle)] font-mono uppercase tracking-wider flex-shrink-0">Live</span>
      </div>
      <div className="min-h-[380px] sm:min-h-[420px]">
        {tab === "route" && <RoutePanel ctx={quoteCtx} />}
        {tab === "compare" && (
          <RouteCompare ctx={quoteCtx} routes={routes} selectedIndex={selectedRouteIndex} onSelect={onSelectRoute} />
        )}
        {tab === "portfolio" && <PortfolioPanel />}
        {tab === "history" && <HistoryPanel historyVersion={historyVersion} />}
      </div>
    </div>
  );
}
